const form = document.getElementById('newsletter-form');
const fields = document.getElementById('hubspot-fields');
const formStatus = document.getElementById('hubspot-subscribe-status');
const heading = document.getElementById('subscribe-heading');
const headingSuccess = document.getElementById('subscribe-heading-success');

function hubspotSubscribe(data) {
	let request = new XMLHttpRequest();

    request.open('POST', site.ajax_url, true);
    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
    request.responseType = 'json';
    request.onload = function () {
      let resp = this.response;
      formStatus.textContent = resp.message;
      if (resp.subscribed) {
         heading.style.display = 'none';
         headingSuccess.style.display = 'block';
         formStatus.style.display = 'none';
         fields.style.display = 'none';
      } else {
         formStatus.style.display = 'block';
      }
    };
    request.send(data);
}

// Footer form submit
form.addEventListener('submit', function(e) {
   e.preventDefault();
   grecaptcha.ready(function() {
      grecaptcha.execute('6Lep30MjAAAAABs8cPdoU2N-_qWHSXAkxtCqKlNH', {action: 'submit'}).then(function(token) {
         let data = new URLSearchParams(new FormData(form)).toString();
         hubspotSubscribe(data);
      });
   });
});